import { useEffect, useState } from "react";
import addicon from '../images/additem.png';
import img1 from '../images/customericon.jpg';
import axios from "axios";
import deleteIcon from '../images/deleteicon.png';
import editIcon from '../images/editicon.png';
import viewIcon from '../images/viewicon.png';
import sortIcon from '../images/arrow.png';
import loadIcon from  '../images/loader2.webp';
import { data } from "react-router";
import Customerdiv from "../common/customerdiv";
const RptRenewalExpired=()=>
{
    const [show,setShow]=useState(false);
    const [msg,setMsg]=useState("");    
    const [customerdata,setCustomerData]=useState([]);
    const [dataToDisplay,setDataToDisplay]=useState([]);
    const [pageData,setPageData]=useState([]);    
    const [sortOrder,setsortOrder]=useState(1);
    const [page,setPage]=useState(1);
    const [pageSize,setPageSize]=useState(10);
    const [totalPage,setTotalPage]=useState(0);
    const [facilities,setFacilities]=useState([]);    
    const [progress,setProgress]=useState(false);
    const apiClient = axios.create({
                baseURL: process.env.REACT_APP_APIURL, // Replace with your API base URL
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization':'Bearer '+localStorage.getItem("token")
                }
            });  
    const columns = [       
        { name: "Company/Customer Details", key: "customer", sortable: true},        
        { name: "Facility", key: "facilityname", sortable: true },        
        { name: "Start Date", key: "startdate", sortable: true },        
        { name: "End Date", key: "enddate", sortable: true },        
        { name: "Plan Name", key: "planname", sortable: true },        
        { name: "Amount", key: "totalamt", sortable: true},              
    ];    
    async function loadJoinings()
    {
        setProgress(true);
        await apiClient.get(process.env.REACT_APP_APIURL+"/api/Report/GetExpiredDetails").then(res=>
        {
            if(res.status==200)
            {
                let arr=res.data.data;
                for(let i=0;i<arr.length;i++)
                {
                    arr[i].startdate=arr[i].startdate.substring(0,10).split("-").reverse().join("-");
                    arr[i].enddate=arr[i].enddate.substring(0,10).split("-").reverse().join("-");
                }
                setCustomerData(arr);
                setDataToDisplay(arr);
                setPageData(arr.slice(0,pageSize));
                let f1=arr.map(e=>e.facilityname);
                let f2=new Set(f1);
                let f3=[...f2].sort();
                if (f3.length === 0) 
                    f3 = ["Facility"];
                else if ((f3[0] || "").trim() === "") 
                    f3[0] = "Facility";
                else f3.splice(0,0,"Facility");                
                setTotalPage(Math.ceil(arr.length/pageSize));                  
            }
        });     
        setProgress(false);   
    }
    function searchData(event)
    {
        if(event.target.id=="searchText")
        {
            if(event.target.value.length>2)
            {
                let searchResult=customerdata.filter((e)=>e.company.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 || e.name.toLowerCase().indexOf(event.target.value.toLowerCase())>=0  );
                setDataToDisplay(searchResult);
                setPageData(searchResult.slice(0,pageSize));
            }
            else
            {
                setDataToDisplay(customerdata);                
                setPageData(customerdata.slice(0,pageSize));
            }
            setPage(1);
        }
        if(event.target.id=="searchFacility")
        {
            if(event.target.value!="Facility")
            {
                let searchResult=customerdata.filter((e)=>e.facilityname==event.target.value);
                setDataToDisplay([...searchResult]);
                setPageData(searchResult.slice(0,pageSize));
            }
            else
            {
                setDataToDisplay([...customerdata]);
                setPageData(customerdata.slice(0,pageSize));
            }
            setPage(1);
        }           
    }    
    function sortData(colname)
    {
        if(colname=="customer")
        {
            let arr=[...dataToDisplay];
            arr.sort((e1,e2)=>
            {
                let x=e1["name"].trim().toLowerCase()>e2["name"].trim().toLowerCase()?1:-1;
                x=x*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            }
            );                                    
            setDataToDisplay(arr);                        
            setPageData(arr.slice(0,pageSize));
            setPage(1);
        } 
        if(colname=="facilityname" || colname=="planname")
        {
            let arr=[...dataToDisplay];
            arr.sort((e1,e2)=>
            {
                let x=e1[colname].trim().toLowerCase()>e2[colname].trim().toLowerCase()?1:-1;
                x=x*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            }
            );                                    
            setDataToDisplay(arr);                        
            setPageData(arr.slice(0,pageSize));
            setPage(1);
        }        
        if(colname=="totalamt")
        {
            let arr=[...customerdata];
            arr.sort((e1,e2)=>
            {
                let d1=isNaN(parseFloat(e1[colname]))?0:parseFloat(e1[colname]);
                let d2=isNaN(parseFloat(e2[colname]))?0:parseFloat(e2[colname]);
                let x=(d1-d2)*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            });
            setDataToDisplay([...arr]);
            setPageData(arr.slice(0,pageSize));
            setPage(1);
        }  
        if(colname=="startdate" || colname=="enddate")      
        {
            let arr=[...customerdata];
            arr.sort((e1,e2)=>
            {
                let d1=new Date(e1[colname].split("-").reverse().join("-"));
                let d2=new Date(e2[colname].split("-").reverse().join("-"));
                let x=(d1-d2)*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            });
            setDataToDisplay([...arr]);
            setPageData(arr.slice(0,pageSize));
            setPage(1);
        }
    }
    function showPage(pagenumber)
    {
        let adata=dataToDisplay.slice((pagenumber-1)*pageSize,(pagenumber)*pageSize);
        setPageData(adata);
        setPage(pagenumber);
    }
    function showPrev(event)
    {
        let p=page;
        if(page>1) p--;        
        showPage(p);
    }
    function showNext(event)
    {
        let p=page;
        if(page<totalPage) p++;        
        showPage(p);
    }
    useEffect(()=>{        
        loadJoinings();        
    },[]);
    return(
        <div>
            <div className="p-2 d-flex">
                <div className="me-2"><input type="text" id="searchText" style={{fontSize:'12px'}} onChange={searchData} placeholder="Search" className="form-control" /></div>
                <div className="me-2">
                </div>
                <div>                    
                </div>                
            </div>
            <div style={{borderRadius:'5px 5px 0px 0px',backgroundColor:'#ffccdd',padding:'5px',fontWeight:'bold'}}>Plan Expired</div>            
            <div style={{overflow:"auto",fontSize:'12px'}}>
                <table className="table table-striped table-bordered">
                    <thead>
                        <tr className="table-primary">
                            <th>S.No.</th>
                            {columns.map((e,i)=>                            
                                <th>{e.name} {e.sortable?(<img src={sortIcon} onClick={()=>{sortData(e.key)}} style={{width:'10px',cursor:'pointer'}}  alt=""/>):(<></>)}</th>                            
                            )}                            
                        </tr>
                    </thead>
                    <tbody>
                        {pageData.map((e,i)=>
                            <tr>
                                <td >{(page-1)*pageSize+i+1}</td>
                                {columns.map((ee,ii)=>                            
                                    ee.key==="customer"?(<Customerdiv cname={e.name} company={e.company} address={e.address} mobile={e.mobile} email={e.email} />):(<td>{e[ee.key]}</td>)
                                )}                                
                            </tr>
                        )}
                    </tbody>
                    <tfoot>
                        <tr className="table-success text-end">
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th>Total</th>
                            <th>{dataToDisplay.reduce((sum,item)=>sum+parseFloat(item.totalamt),0)}</th>
                        </tr>
                        <tr className="table-primary">
                            <th colSpan="2"><input type="button" onClick={showPrev} value="<<<" className="btn btn-success btn-sm" /></th>
                            <th colSpan="3" className="text-center"></th>
                            <th colSpan="2" className="text-end"><input type="button" value=">>>" onClick={showNext} className="btn btn-success btn-sm" /></th>
                        </tr>
                        <tr className="table-primary">
                            <th colSpan="7">Total {dataToDisplay.length} Expired as on Date</th>                        
                        </tr>
                    </tfoot>
                </table>
            </div>                                       
                {progress && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md">
                                <div className="modal-body p-4">                                                                                                                                                
                                    <img src={loadIcon} alt="" style={{position:'fixed',left:'50%',top:'45%',width:'50px'}}/>
                                </div>                                                            
                        </div>
                    </div>
                )}
        </div>
    );
}
export default RptRenewalExpired;